<template>
  <AdminLayout>
    <Head title="Vend Order Re-Poster" />

    <div class="headline flex flex-col md:flex-row justify-between items-start md:items-center mx-4 sm:mx-12">
      <h2 class="text-2xl font-semibold text-blue-600">Vend Order Re-Poster</h2>

      <div class="relative inline-flex self-start my-5">
        <div class="input-group-checkbox items-center mr-4">
          <div class="input-checkbox-container">
            <input
              v-model="form.up_to_today"
              id="up_to_today"
              name="up_to_today"
              type="checkbox"
            />
          </div>
          <div class="input-label-container">
            <label for="up_to_today"> Up to Present </label>
          </div>
        </div>
        <div class="input-group-checkbox items-center mr-4">
          <div class="input-checkbox-container">
            <input
              v-model="form.closed"
              id="only_closed"
              name="only_closed"
              type="checkbox"
            />
          </div>
          <div class="input-label-container">
            <label for="only_closed"> Closed </label>
          </div>
        </div>
        <div class="input-group mr-2">
          <input
            type="text"
            v-model="form.invoice"
            placeholder="Invoice #"
          />
        </div>
        <div class="input-group mr-2">
          <input
            type="text"
            v-model="form.customer"
            placeholder="Customer Email"
          />
        </div>
        <div class="input-group mr-2">
          <select
            v-model="form.location_id"
            id="product-regulated"
            class="bg-gray-100"
          >
            <option :value="null">All Locations</option>
            <option
              v-for="location in locations"
              :key="location.id"
              :value="location.id"
            >
              {{ location.name }}
            </option>
          </select>
        </div>

        <!--                <button @click="download()" type="button" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-100 bg-blue-600 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600">-->
        <!--                    Download-->
        <!--                </button>-->
      </div>
    </div>

    <!-- Page is loading with results -->
    <div
      class="mx-4 sm:mx-12"
      v-if="loading"
    >
      Loading...
    </div>
    <!-- END: Page is loading with results -->

    <!-- Page and results have fully loaded -->
    <div
      class="flex-1 bg-gray-100"
      v-else
    >
      <div class="table-container overflow-x-auto w-full">
        <table class="w-full whitespace-nowrap overflow-hidden">
          <thead>
            <tr class="header-row">
              <!-- <th>ID</th> -->
              <th>Customer</th>
              <th>Invoice #</th>
              <th>Status</th>
              <th>Salve ID</th>
              <th>Salve Status</th>
              <th>Date</th>
              <th>Total</th>
              <th class="text-center"></th>
            </tr>
          </thead>
          <tbody class="table-rows">
            <tr v-for="order in orders">
              <td>{{ order.customer }}</td>
              <td>{{ order.invoice_number || order.id }}</td>
              <td>{{ order.status }}</td>
              <td>
                <a
                  v-if="order.salve_id"
                  :href="route('orders.show', { order: order.salve_id })"
                  >{{ order.salve_id }}</a
                >
                <span v-else>NA</span>
              </td>
              <td>{{ order.salve_status }}</td>
              <td>{{ order.date }}</td>
              <td>{{ order.total_price }}</td>
              <td>
                <button
                  @click="postOrder(order, 'hook', false)"
                  type="button"
                  class="font-medium text-indigo-600 hover:text-indigo-500"
                >
                  Re-Hook
                </button>
                <!--                                <button @click="postOrder(order, 'post', false)" type="button" class="ml-3 font-medium text-indigo-600 hover:text-indigo-500">-->
                <!--                                    Re-Post-->
                <!--                                </button>-->
                <!--                                <button @click="postOrder(order, 'post', true)" type="button" class="ml-3 font-medium text-indigo-600 hover:text-indigo-500">-->
                <!--                                    Skip-Post-->
                <!--                                </button>-->
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <button
          @click.prevent="changePage(-1)"
          type="button"
          class="mr-3 inline-flex items-center px-4 py-2 rounded-md border border-gray-400 bg-gray-100 font-medium text-gray-700 shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 sm:mt-0 w-auto text-sm"
        >
          Previous
        </button>

        {{ params.page }}

        <button
          @click.prevent="changePage(1)"
          type="button"
          class="ml-3 inline-flex items-center px-4 py-2 rounded-md border border-gray-400 bg-gray-100 font-medium text-gray-700 shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 sm:mt-0 w-auto text-sm"
        >
          Next
        </button>
      </div>
    </div>
    <!-- END: Page and results have fully loaded -->
  </AdminLayout>
</template>

<script>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, Link } from '@inertiajs/vue3'
import { ChevronDownIcon, ArrowCircleDownIcon } from '@heroicons/vue/solid'
import interactsWithCurrentLocation from '@/Mixins/interactsWithCurrentLocation'
import MultiSelectInput from '@/Components/Forms/MultiSelectInput'
import accessesCompany from '@/Mixins/accessesCompany'

export default {
  mixins: [interactsWithCurrentLocation, accessesCompany],

  components: {
    AdminLayout,
    Head,
    Link,
    ChevronDownIcon,
    ArrowCircleDownIcon,
    MultiSelectInput
  },

  props: {
    params: Object,
    locations: Array,
    orders: Array
  },

  data() {
    return {
      loading: true,
      form: this.$inertia.form({
        location_id: this.params.location_id,
        customer: this.params.customer,
        invoice: this.params.invoice,
        up_to_today: this.params.up_to_today,
        closed: this.params.closed,
        page: parseInt(this.params.page)
      })
    }
  },

  created() {
    this.loading = false
  },

  watch: {
    'form.location_id': function (newVal, oldVal) {
      this.form.page = 1
      this.update()
    },
    'form.customer': function (newVal, oldVal) {
      this.form.page = 1
      this.update()
    },
    'form.invoice': function (newVal, oldVal) {
      this.form.page = 1
      this.update()
    },
    'form.up_to_today': function (newVal, oldVal) {
      this.form.page = 1
      this.update()
    },
    'form.closed': function (newVal, oldVal) {
      this.form.page = 1
      this.update()
    },
    'form.page': function (newVal, oldVal) {
      this.update()
    }
  },

  methods: {
    update: _.debounce(
      function () {
        this.loading = true

        this.form.get(route('integrations.vend.orders.index'))
      },
      500,
      {
        leading: false,
        trailing: true
      }
    ),

    postOrder(order, method, skipProcessing) {
      if (!window.confirm('Are you sure you want to re-post?')) {
        return
      }

      axios
        .post(route('integrations.vend.orders.store'), {
          source_id: order.id,
          method: method,
          skip_processing: skipProcessing
        })
        .then((response) => {
          console.log(response)
        })
    },

    changePage(dir) {
      this.form.page += dir
    }
  }
}
</script>
